/**
 * Scheme interfaces for the schemes module
 */

/**
 * Represents a scheme in the system
 */
export interface Scheme {
  id: number;
  scheme_name: string;
  start_date: string;
  end_date: string;
  status: string | number;
  program_id: number;
  user_type?: number;
  scheme_type?: string;
  based_on?: string;
  calculation_based_on?: string;
  type_of_calculation?: string;
  benefit_based_on?: string;
  created_at?: string;
  updated_at?: string;
}

/**
 * Response from the get schemes API
 */
export interface GetSchemesResponse {
  status: number;
  data: Scheme[];
  message?: string;
}

/**
 * Form data for extending scheme date
 */
export interface ExtendSchemeData {
  end_date: string;
}

/**
 * Response from extend scheme API
 */
export interface ExtendSchemeResponse {
  status: number;
  data: string | { message: string };
  message?: string;
}

/**
 * Request payload for extending scheme
 */
export interface ExtendSchemeRequest {
  end_date: string;
}
